import { useEffect, useState } from 'react'
import { useGetUser } from '@dhl/keycloak-user-api'
import {
  businessUnitRolePrefix,
  convertRoleToBusinessUnit,
  convertToRoleCategories,
  type RoleCategory,
  type RoleName,
} from '~/modules/adminusers/model'

export const useKeyCloakUser = (userId: string) => {
  const [userRoles, setUserRoles] = useState<RoleName[] | undefined>([])
  const [userBusinessUnits, setUserBusinessUnits] = useState<string[] | undefined>([])
  const [userRoleCategories, setUserRoleCategories] = useState<RoleCategory[] | undefined>([])
  const { data: user, refetch } = useGetUser(userId)

  useEffect(() => {
    if (user) {
      const [roles, businessUnits] = (user?.roles?.map((r) => r.name as RoleName) || []).reduce(
        ([roles, businessUnits], userRole) => {
          if (userRole.startsWith(businessUnitRolePrefix)) {
            return [roles, [...businessUnits, convertRoleToBusinessUnit(userRole)]]
          }
          return [[...roles, userRole], businessUnits]
        },
        [[] as RoleName[], [] as string[]]
      )
      setUserRoles(roles)
      setUserBusinessUnits(businessUnits)
      setUserRoleCategories(convertToRoleCategories(roles, true))
    }
  }, [user])

  return { user, userRoles, userRoleCategories, userBusinessUnits, refetch }
}
